// extracted by mini-css-extract-plugin
export default {"cls1":"ToolsMenu-cls1_vNF","cls2":"ToolsMenu-cls2_Rpa ToolsMenu-cls1_vNF"};